import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, LayersIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { heroBenefits } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
const benefitIcons = [BookOpenIcon, LayersIcon, GiftIcon];
const assurances = ['Instant Digital Access', 'Ready-to-Use PDF Resources', 'Designed for Nail Educators', 'One-Time Payment'];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-92" data-mp="1ucm66ai8aufx">
      <div className="mx-auto max-w-4xl text-center" data-id="element-93" data-mp="1qba9xm4unayr">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-94" data-mp="1q9z9nwam4lce">
          For Nail Educators, Instructors & Academy Owners
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-95" data-mp="9whhae3vqwcd">
          Your Next Nail Class Could Be Ready <Accent data-id="element-96" data-mp="3de4n5ixvw657">in Minutes — Not Hours.</Accent>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-97" data-mp="2zfwsxis8fixq">
          Stop losing your evenings building lesson plans, demonstrations, checklists and
          assessments from a blank page.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-98" data-mp="2pnqrlig3bp5v">
          Open a structured lesson, follow it and walk into class prepared — so your time goes into
          teaching your students, not rebuilding the same material again.
        </p>
      </div>

      <div className="relative mx-auto mt-10 w-full max-w-[1000px]" data-id="element-99" data-mp="2koe54yt4sk3t">
        <div aria-hidden="true" className="absolute inset-x-[6%] bottom-[4%] top-[18%] rounded-[50%] bg-brand-oatmeal opacity-80 blur-3xl" data-id="element-100" data-mp="26rhh154edgqm" />
        <img src={MOCKUP_URL} alt="Nail Educator Ready — six teaching volumes shown on books, tablet, desktop and phone" width={1536} height={1024} loading="eager" decoding="async" className="relative mx-auto block w-full max-w-[560px] object-contain lg:max-w-[880px]" style={{
        filter: 'drop-shadow(0 34px 40px rgba(120, 96, 56, 0.22))'
      }} data-id="element-101" data-mp="ha3qhlfg98ds" />
      </div>

      <div className="mx-auto mt-10 max-w-4xl" data-id="element-102" data-mp="107wtsotzjkbp">
        <ul className="grid gap-7 border-y border-brand-charcoal/12 py-8 sm:grid-cols-3" role="list" data-id="element-103" data-mp="w6l0o9bwkgyr">
          {heroBenefits.map((benefit, index) => {
          const Icon = benefitIcons[index];
          return <li key={benefit.label} className="text-center" data-id="element-104" data-mp="m859y7gsf9ps" data-mpi={index}>
                <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-brand-ivory" data-id="element-105" data-mp="3bxz4476nxk74">
                  <Icon className="h-[18px] w-[18px] text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-106" data-mp="36ywbjm7vd6g1" />
                </span>
                <p className="mt-3 font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-107" data-mp="2wwsef87z23qc">
                  {benefit.label}
                </p>
                <p className="mx-auto mt-1.5 max-w-[16rem] text-[13px] leading-relaxed text-brand-charcoal/65" data-id="element-108" data-mp="36t55rzg1o5hx">
                  {benefit.description}
                </p>
              </li>;
        })}
        </ul>
      </div>

      <CtaBlock label="Yes! I Want Nail Educator Ready™" className="mt-10" data-id="element-109" data-mp="3fl76zzxxtpt9" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-110" data-mp="3kjs1rjuf7hab">
        {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-111" data-mp="3pko6u0qid9hb">
            <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-112" data-mp="3ugwslwz7o0xg" />
            {item}
          </li>)}
      </ul>
    </section>;
}